import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export interface StatusNoteData { title: string; message: string; label: string; required: boolean; accept: string; }

/** Confirma un cambio de estado y pide el motivo (obligatorio u opcional). */
@Component({
  selector: 'app-status-note-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="msg" [innerHTML]="data.message"></p>
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ data.label }}</mat-label>
        <textarea matInput rows="3" maxlength="500" [(ngModel)]="note" cdkFocusInitial></textarea>
        @if (data.required) {<mat-hint>Obligatorio</mat-hint>}
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" mat-dialog-close>Cancelar</button>
      <button mat-flat-button color="primary" type="button" [disabled]="data.required && !note.trim()" (click)="ref.close({ note: note.trim() })">
        {{ data.accept }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`.full { width: 100%; min-width: 300px; } .msg { margin: 0 0 12px; font-size: 14px; }`],
})
export class StatusNoteDialogComponent {
  readonly data = inject<StatusNoteData>(MAT_DIALOG_DATA);
  readonly ref = inject(MatDialogRef<StatusNoteDialogComponent>);
  note = '';
}
